import Model from './Model'

export default class UserProgram extends Model {
  resource() {
    return 'user-programs'
  }
}
